<template>
  <div class="booking-summary__offers booking-summary-callout booking-summary-callout--info">
    <strong class="callout-title">
        <svg width="25" height="30" viewBox="0 0 1792 1792">
            <path d="M576 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm1067 576q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"/>
        </svg>
        <span>Would you like to include an offer in your booking?</span>
    </strong>

    <div class="offer-selection">
        <div class="flex align-center inline-checkbox-outer" 
          v-for="offer in offers"
          v-bind:key="offer.id">
          <label class="input__inline-label">
            <input type="radio" :id="offer.id" name="offer" :value="offer.id" v-model="selectedOffer">
            {{ offer.name }}
          </label>
        </div>

        <div class="flex align-center inline-checkbox-outer">
          <label class="input__inline-label">
            <input type="radio" :id="null" name="offer" :value="null" v-model="selectedOffer">
            No thanks
          </label>
        </div>
    </div>
  </div>
</template>

<script>
  import inputRadio from './inputRadio'

  export default {
    name: 'offersInput',
    props: [
      'offers',
      'value'
    ],
    components: {
      inputRadio
    },
    data () {
      return {
        selectedOffer: this.value || null
      }
    },
    watch: {
      selectedOffer: function (newVal) {
        this.$emit('input', this.selectedOffer)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// offersInput.vue?1486c0f3